import { FormControl, FormGroup } from "react-bootstrap";

interface IProps {
    dateRange: number,
    status: number,
    centerAlias: string,
    onDateRangeChange: (dateRange: number) => void,
    onStatusChange: (status: number) => void
}

const Filter = (props: IProps) => {
    const handleDateRangeChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        props.onDateRangeChange(parseInt(e.currentTarget.value));
    };

    const handleStatusChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        props.onStatusChange(parseInt(e.currentTarget.value));
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <FormGroup style={{ marginBottom: 0, marginRight: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: 5 }}>Filter By Date Range:</div>
                    <div>
                        <FormControl
                            componentClass='select'
                            value={props.dateRange}
                            onChange={handleDateRangeChange}
                        >
                            <option value={0}>- Show All -</option>
                            <option value={90}>Past 90 Days</option>
                            <option value={120}>Past 120 Days</option>
                            <option value={180}>Past 180 Days</option>
                            <option value={365}>Past Year</option>
                            <option value={730}>Past 2 Years</option>
                        </FormControl>
                    </div>
                </div>
            </FormGroup>

            <FormGroup style={{ marginBottom: 0, marginRight: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: 5 }}>Filter by Status:</div>
                    <div>
                        <FormControl
                            componentClass='select'
                            value={props.status}
                            onChange={handleStatusChange}
                        >
                            <option value={0}>- All -</option>
                            <option value={2}>Submitted by {props.centerAlias}</option>
                            <option value={-2}>Awaiting Response From {props.centerAlias}</option>
                            <option value={3}>Pending More Data From {props.centerAlias}</option>
                            <option value={4}>Accepted by {props.centerAlias}</option>
                            <option value={-4}>Accepted by Recipient Center</option>
                            <option value={8}>Disputed By {props.centerAlias}</option>
                            <option value={-8}>Disputed By Recipient Center</option>
                            <option value={10}>Payment Received By Recipient Center</option>
                            <option value={20}>Payment Sent to {props.centerAlias}</option>
                            <option value={-1}>Billed Manually</option>
                        </FormControl>
                    </div>
                </div>
            </FormGroup>
        </div>
    );
}

export default Filter;